const _push = (stack, set) => (item) => {
    if (set.has(item))
        return [new Error('Duplicated item has been pushed to the stack.'), null];
    stack.unshift(item);
    set.add(item);
    return [null, item];
};
const _pop = (stack, set) => (expected) => {
    if (stack.length === 0) {
        return [new Error('Trying to extract item from the empty stack'), null];
    }
    const last = stack.shift();
    set.delete(last);
    return (expected === undefined || last === expected
        ? [null, last]
        : [new Error('Extracted item is not equal to expected one'), null]);
};
const UniqueStackApi = (stack, set) => ({
    push: _push(stack, set),
    pop: _pop(stack, set),
    get size() {
        return stack.length;
    },
    get items() {
        return stack.slice();
    },
});
const UniqueStack = () => UniqueStackApi([], new Set());
export default UniqueStack;
